import React from "react";
import { Link } from "react-router-dom";
import { useShop } from "../lib/shop";
import { useAuth } from "../lib/auth";
import { ProductCard } from "../components/ProductCard";
import { Heart } from "lucide-react";
import { useSEO } from "../lib/useSEO";

export default function Wishlist() {
  useSEO({ title: "Wishlist | Joy Pearl", description: "Your saved Joy Pearl jewellery and gift items. Sign in to sync across devices.", noIndex: true });
  const { wishlist } = useShop();
  const { user, loading } = useAuth();

  if (loading) return <div className="jp-container py-20 text-center text-brand-muted">Loading…</div>;
  if (!user) return (
    <div className="jp-container py-20 text-center" data-testid="wishlist-empty">
      <h1 className="font-serif text-3xl mb-3">Sign in to view your wishlist</h1>
      <Link to="/login" className="jp-btn-primary mt-4 inline-flex">Sign In</Link>
    </div>
  );

  return (
    <div className="jp-container py-8 md:py-12" data-testid="wishlist-page">
      <h1 className="font-serif text-3xl md:text-5xl mb-8">Wishlist</h1>
      {!wishlist.products?.length ? (
        <div className="text-center py-16">
          <Heart size={36} className="mx-auto text-brand-muted mb-4"/>
          <p className="text-brand-muted">Tap the heart on any product to save it here.</p>
          <Link to="/products" className="jp-btn-primary mt-6 inline-flex">Browse Shop</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {wishlist.products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
